import React, { Component } from 'react';
import { connect } from 'react-redux';
import CountTo from 'react-count-to';
import './counter.scss';

class Counter extends Component {
  render() {

    const { record } = this.props;
    // console.log('record', record);

    const fn = value => <span className="counter-content__num">{ value }</span>

    return (
      <div className="counter-content">
        <ul className="counter-content__group">
          {
            record.map((item, index) => {
              return (
                <li className="counter-content__item" key={ index }>
                  <CountTo to={item.get('count')} speed={1500}>{ fn }</CountTo>
                  <p className="counter-content__desc">{ item.get('des') }</p>
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }
}

const mapState = (state) => ({
  record: state.getIn(['home', 'record'])
});

export default connect(mapState, null)(Counter);